// extracted by mini-css-extract-plugin
export default {"MainCont":"Oven_MainCont__BdtOh","LeftCont":"Oven_LeftCont__ccNGp","RightCont":"Oven_RightCont__utLRR"};